import * as React from 'react';
import { merge } from 'ramda';
import {
  IUIUrval,
  TEDInputUrvalType,
  TEDUrvalVisibility,
} from '../../../../../../Types/UrvalTypes';
import {
  IFormValues,
  IWarnings,
  IFormActions,
} from '../../../../../../Types/FormTypes';
import { convertSavedUrvalPropertiesToInputUrval } from '../../../../Utils/convertUIUrvalToTEDUrval';
import SaveUrvalForm from '../_Common/SaveUrvalForm';
import Logger from '../../../../../../Utils/Logger';

interface IProps {
  setOKClick: (okClick: any) => void;
  modifyUrval: (
    urval: IUIUrval,
    inputUrval: TEDInputUrvalType
  ) => Promise<void>;
  urval: IUIUrval;
  collectionName: string;
  onSuccess?: () => void;
  userId?: string;
  rutinId: number;
  usageCode?: string;
  initialValues: {
    name: string;
    visibility: TEDUrvalVisibility;
    description: string | null;
  };
  kodplanID: string;
  availableVisibilityOptions: TEDUrvalVisibility[];
}

class ModifyUrvalForm extends React.Component<IProps> {
  onSubmit = (
    values: IFormValues,
    warnings: IWarnings,
    formActions: IFormActions
  ) => {
    const newValues = {
      namn: values.name as string,
      beskrivning: values.description as string,
      synlighet: values.visibility as TEDUrvalVisibility,
      synligAnvID: this.props.userId,
      kontoplanID: this.props.kodplanID,
      usagecode: this.props.usageCode || null,
    };

    let inputSelection: TEDInputUrvalType | undefined;

    if (this.props.urval.savedUrvalProps) {
      inputSelection = convertSavedUrvalPropertiesToInputUrval(
        this.props.urval.savedUrvalProps
      );
      inputSelection = merge(inputSelection, newValues);

      if (inputSelection != null) {
        this.props
          .modifyUrval(this.props.urval, inputSelection)
          .then(() => {
            if (this.props.onSuccess != null) {
              this.props.onSuccess();
            }
          })
          .catch(reason => {
            Logger.error(reason);
          });
      } else {
        Logger.error('inputSelection is null or undefined');
      }
    } else {
      Logger.error('Selection does not contain savedSelectionProps');
    }
  };

  render() {
    return (
      <SaveUrvalForm
        onSubmit={this.onSubmit}
        setOKClick={this.props.setOKClick}
        initialValues={this.props.initialValues}
        availableVisibilityOptions={this.props.availableVisibilityOptions}
      />
    );
  }
}

export default ModifyUrvalForm;
